var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "mx-n3 px-3",
    attrs: {
      "width": "100%",
      "max-width": "1080",
      "height": "100%"
    }
  }, [_c('list-heading', _vm._b({}, 'list-heading', {
    title: _vm.title
  }, false)), _c('report-view-head', _vm._b({
    staticClass: "mb-4"
  }, 'report-view-head', {
    process: _vm.process,
    planDate: _vm.planDate
  }, false)), _c('report-view-body', _vm._b({}, 'report-view-body', {
    process: _vm.process,
    planDate: _vm.planDate
  }, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }